import { Button } from 'antd';
import React from 'react';

interface NavigationButtonProps {
    label: string;
    type: "link" | "text" | "default" | "primary" | "dashed" | undefined;
    onClick: () => void;
    icon?: any;
    block?: boolean;
    disable?: boolean;
    
}

const NavigationButton: React.FC<NavigationButtonProps> = ({ type = "default", label, onClick, icon,block=false,disable=false }) => {
    return (
        <Button
            type={type}
            icon={icon}
            block={block}
            disabled={disable}
            onClick={onClick}
            className={`h-11 md:h-9 md:px-[14px] px-[20px] py-[10px] md:py-[8px]  ${type==='primary'? "common-primary-button":"text-[#667085] text-sm font-medium font-['Inter'] leading-tight  "} ${disable?'':''}`}
        >
           {label}
        </Button>
    );
};

export default NavigationButton;
